import snakeCase from 'lodash/snakeCase';

import toSnakeCase from './snakecaseKeys';

const createPayloadForFeatureToggle = arrConfig => ({
  configurationFor: arrConfig.map(({ action, options }) => ({
    action: snakeCase(action),
    options: toSnakeCase(options),
  })),
});

export default createPayloadForFeatureToggle;



// WEBPACK FOOTER //
// ./src/utils/createPayloadForFeatureToggle.js